// Listes des fonctions de tris
    import functions from '@/functions/functions.js'
    import functionsDate from '@/functions/date.js'

    const mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
    const moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');
    const jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
    const jours_fr = new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche');
    const joursInput = new Array('dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi');
    const heure_numerique = new Array('00', '01', '02', '03', '04', '05', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23')

    // listeElements --> Liste de tous les élements à trier
    // order --> AZ pour croissant ou alphabétique
    // order --> ZA pour décroissant ou alphabétique inversé
    // type --> nom du champs sur lequel on se base pour trier
    // typeDeux --> nom du champs sur lequel on se base pour trier qui est dans un tableau (nom du tableau à indiquer dans type)

    const fonctionsTris = {
        orderBy(listeElements, order, type, id){
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? functions.supprimerCaracteres(a[type], id).toString().localeCompare(functions.supprimerCaracteres(b[type].toString(), id), undefined ,{ numeric: true }) : functions.supprimerCaracteres(b[type], id).toString().localeCompare(functions.supprimerCaracteres(a[type].toString(), id), undefined ,{ numeric: true });
            });
        },

        orderByElement(listeElements, order){
            return listeElements.slice().sort((a, b) => {
                 return order === 'AZ' ? a.localeCompare(b) : b.localeCompare(a);
            });
        },

        orderByDeux(listeElements, order, type, typeDeux) {
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? a[type][typeDeux].toString().localeCompare(b[type][typeDeux].toString(), undefined ,{ numeric: true }) : b[type][typeDeux].toString().localeCompare(a[type][typeDeux].toString(), undefined ,{ numeric: true });
            });
        },

        orderByTrois(listeElements, order, type, typeDeux, typeTrois) {
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? a[type][typeDeux][typeTrois].toString().localeCompare(b[type][typeDeux][typeTrois].toString(), undefined ,{ numeric: true }) : b[type][typeDeux][typeTrois].toString().localeCompare(a[type][typeDeux][typeTrois].toString(), undefined ,{ numeric: true });
            });
        },

        orderByDate(listeElements, order, type) {
            function compare(A, B){
                const a = new Date(A[type].date.year, A[type].date.month - 1, A[type].date.day);
                const b = new Date(B[type].date.year, B[type].date.month - 1, B[type].date.day);

                if(order === 'AZ'){
                    if(a < b) return -1
                    if(a > b) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(a > b) return -1
                    if(a > b) return 1
                    return 0
                }
            }

            return listeElements.slice().sort(compare)
        },


        orderByDateID(listeElements, order) {
            function compare(A, B){
                const a = new Date(A.date.year, A.date.month - 1, A.date.day);
                const b = new Date(B.date.year, B.date.month - 1, B.date.day);

                if(order === 'AZ'){
                    if(a < b) return -1
                    if(a > b) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(a > b) return -1
                    if(a > b) return 1
                    return 0
                }
            }

            return listeElements.slice().sort(compare)
        },

        orderNumber(listeElements, order) {
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? Number(a) - Number(b) : Number(b) - Number(a);
            });
        },

        orderNumberType(listeElements, order, type) {
            function compare(a, b){
                if(order === 'AZ'){
                    if(Number(a[type]) < Number(b[type])) return -1
                    if(Number(a[type]) > Number(b[type])) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(Number(a[type]) > Number(b[type])) return -1
                    if(Number(a[type]) < Number(b[type])) return 1
                    return 0
                }
            }
            return listeElements.slice().sort(compare);
        }, 

        orderNumberTypeDeux(listeElements, order, type, typeDeux) {
            function compare(a, b){
                if(order === 'AZ'){
                    if(Number(a[type][typeDeux]) < Number(b[type][typeDeux])) return -1
                    if(Number(a[type][typeDeux]) > Number(b[type][typeDeux])) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(Number(a[type][typeDeux]) > Number(b[type][typeDeux])) return -1
                    if(Number(a[type][typeDeux]) < Number(b[type][typeDeux])) return 1
                    return 0
                }
            }
            return listeElements.slice().sort(compare);
        }
    }

    export default fonctionsTris


// WEBPACK FOOTER //
// ./src/functions/tris.js